import React, { useState, useContext } from "react";
import {
  Paper,
  Stack,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";

import MusicNoteIcon from "@mui/icons-material/MusicNote";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import LibraryMusicOutlinedIcon from '@mui/icons-material/LibraryMusicOutlined';
import QueueMusicIcon from '@material-ui/icons/QueueMusic';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SubscriptionsOutlinedIcon from '@mui/icons-material/SubscriptionsOutlined';


import TrackContext from "../../contexts/track-context";
import CookieManager from "../../services/CookieManager";

export default function MobileTopNavigation() {
  const history = useHistory();
  const location = useLocation();
  const trackContext = useContext(TrackContext);
  const [userDetails, setUserDetails] = useState(JSON.parse(CookieManager.getCookie("user-data") || "{}"));

  const [anchorEl_0, setAnchorEl_0] = useState(null);
  const [anchorEl_1, setAnchorEl_1] = useState(null);

  const navItems = [
    {
      id: "music",
      paths: ["/library", "/music/tracks", "/music/albums"],
      icon: <MusicNoteIcon />,
    },
    {
      id: "project",
      paths: ["/projects"],
      icon: <AssignmentIcon />,
    },
    {
      id: "history",
      paths: ["/history"],
      icon: <SubscriptionsOutlinedIcon />,
    },
    {
      id: "favorites",
      paths: ["/favourites"],
      icon: <FavoriteBorderIcon />,
    },
    {
      id: "lib",
      paths: ["/sfx", "/new-inspiration", "/catalogs"],
      icon: <GraphicEqIcon />,
      menu: true,
    },
    {
      id: "profile",
      paths: ["/profile", "/support"],
      icon: <PersonOutlineIcon />,
      menu: true,
    },
  ];

  const handleNavigation = (event, item) => {
    if (item.menu) {

      item.id === "profile" ? setAnchorEl_0(event.currentTarget) : setAnchorEl_1(event.currentTarget);
      return;
    }

    setAnchorEl_0(null);
    setAnchorEl_1(null);

    const destination = item.paths[0];

    if (location.pathname !== destination) {
      history.push(destination);
    }
  };

  const handleClose = () => {
    setAnchorEl_0(null);
    setAnchorEl_1(null);
  };

  const handleMenuNavigate = (path) => {
    handleClose();

    if (location.pathname !== path) {
      history.push(path);
    }
  };

  return (
    <>
      <Paper
        elevation={8}
        sx={{
          position: "fixed",
          top: 16,
          left: 4,
          right: 4,
          zIndex: 1300,
          height: 60,
          borderRadius: "999px !important",
          // bgcolor: "#ec0a7d !important",
          bgcolor: "rgb(var(--pink)) !important",
          color: "#fff !important",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 1,
          boxShadow: "0px 3px 10px rgba(var(--shadow))",
          border: "2px solid #fff",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-evenly"
          sx={{ width: "100%" }}
        >
          {navItems.map((item) => {
            const active = item.paths.some((path) =>
              location.pathname.startsWith(path)
            );

            return (
              <IconButton
                key={item.id}
                onClick={(e) => handleNavigation(e, item)}
                sx={{
                  // color: active
                  //   ? "#fff"
                  //   : "rgba(255,255,255,.55)",

                  color: "#fff !important",

                  transform: active
                    ? "scale(1.2)"
                    : "scale(1)",

                  transition: "all .2s ease",

                  "&:hover": {
                    color: "#fff",
                    bgcolor: "rgba(255,255,255,.12)",
                  },

                  "& .MuiSvgIcon-root": {
                    fontSize: 28,
                  },
                }}
              >
                {item.icon}
              </IconButton>
            );
          })}
        </Stack>
      </Paper>

      <Menu
        anchorEl={anchorEl_0}
        open={Boolean(anchorEl_0)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            mt: 1,
            ml: 1,
            bgcolor: "#111 !important",
            color: "#fff !important",
            borderRadius: 2,
            minWidth: 190,
            "& .MuiMenuItem-root": {
                minHeight: 44,
                display: "flex",
                alignItems: "center",
                whiteSpace: "nowrap",
            },
            "& .MuiListItemIcon-root, & .MuiSvgIcon-root": {
                color: "#fff !important",
            },
          },
        }}
      >
        {userDetails?.userType === "ADMIN" &&
        <MenuItem onClick={() => handleMenuNavigate("/admin")}>
          <ListItemIcon className="pl-1">
            <DashboardIcon sx={{ color: "#fff" }} />
          </ListItemIcon>
          <ListItemText className="pr-1" primary="Dashboard" />
        </MenuItem>}

        <MenuItem onClick={() => handleMenuNavigate("/profile")}>
          <ListItemIcon className="pl-1">
            <AccountCircleOutlinedIcon sx={{ color: "#fff" }} />
          </ListItemIcon>
          <ListItemText className="pr-1" primary="Account" />
        </MenuItem>

        <MenuItem onClick={() => handleMenuNavigate("/support")}>
          <ListItemIcon className="pl-1">
            <HelpOutlineIcon sx={{ color: "#fff" }} />
          </ListItemIcon>
          <ListItemText className="pr-1" primary="Support" />
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClose();

            //Perform logout
            trackContext.setShowLogoutPopup(true);
          }}
        >
          <ListItemIcon className="pl-1">
            <LogoutIcon sx={{ color: "#fff" }} />
          </ListItemIcon>
          <ListItemText className="pr-1" primary="Log out" />
        </MenuItem>
      </Menu>

      <Menu
        anchorEl={anchorEl_1}
        open={Boolean(anchorEl_1)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            mt: 1,
            ml: 1,
            bgcolor: "#111 !important",
            color: "#fff !important",
            borderRadius: 2,
            minWidth: 190,
            "& .MuiMenuItem-root": {
                minHeight: 44,
                display: "flex",
                alignItems: "center",
                whiteSpace: "nowrap",
            },
            "& .MuiListItemIcon-root, & .MuiSvgIcon-root": {
                color: "#fff !important",
            },
          },
        }}
      >
        <MenuItem onClick={() => handleMenuNavigate("/sfx")}>
          <ListItemIcon className="pl-1">
            <GraphicEqIcon sx={{ color: "#fff" }} />
          </ListItemIcon>
          <ListItemText className="pr-1" primary="SFX" />
        </MenuItem>

        <MenuItem onClick={() => handleMenuNavigate("/new-inspiration")}>
          <ListItemIcon className="pl-1">
            <QueueMusicIcon className="text-white" />
          </ListItemIcon>
          <ListItemText className="pr-1" primary="Now Out" />
        </MenuItem>

        <MenuItem onClick={() => handleMenuNavigate("/catalogs")}>
          <ListItemIcon className="pl-1">
            <LibraryMusicOutlinedIcon sx={{ color: "#fff" }} />
          </ListItemIcon>
          <ListItemText className="pr-1" primary="Labels" />
        </MenuItem>

      </Menu>
    </>
  );
}